// Дзеркало Prisma enum StudyMode. Режим занять (D9): щотижневий або цикловий (блок днів на клінічній кафедрі).
// Значення ідентичні apps/api/prisma/schema.prisma (перевіряє test/enums.spec.ts). Підписи — лише тут.
export const StudyMode = {
    WEEKLY: 'WEEKLY',
    CYCLE: 'CYCLE',
};
/** Значення в порядку оголошення в схемі. */
export const STUDY_MODE_VALUES = ['WEEKLY', 'CYCLE'];
export const STUDY_MODE_LABELS = {
    WEEKLY: 'Щотижневий',
    CYCLE: 'Цикловий',
};
//# sourceMappingURL=study-mode.js.map